import PropTypes from 'prop-types';
import React from 'react';
import styled, {css} from 'styled-components';
import { rem } from 'polished';

const StyledHomepageH5 = styled.h5`
    ${({ theme }) => theme.ADAFont('22px')};
    font-weight: 500;
    font-family: ${({ theme }) => theme.secondaryFont};
    text-transform: uppercase;
    color: #343638;

    ${({ theme }) => theme.tablet`
      ${({ theme }) => theme.ADAFont('18px')};
   `}

   // How it works section
   ${({section}) => (section == 'howItWorks') && css`
      color: #FFFFFF;
      margin-bottom: ${rem('4px')};
   `}
 
   // Steps Section
   ${({section}) => (section == 'steps') && css`
      color: #343638;
   `}

   // Terms pages
   ${({section}) => (section == 'terms') && css`
      text-align: center;
      margin-bottom: ${rem('0px')};
   `}

   // Agent Enrollment Page
   ${({section}) => (section == 'agent') && css`
      ${({ theme }) => theme.ADAFont('20px')}
      text-align: center;
      margin-bottom: ${rem('0px')};
   `}

   // Contact Us Page
   ${({section}) => (section == 'contactUs') && css`
      ${({ theme }) => theme.ADAFont('17px')}
      text-align: center;
      margin-bottom: ${rem('0px')};
   `}

   // Hotel Landing
   ${({section}) => (section == 'hotelLanding') && css`
      ${({ theme }) => theme.ADAFont('20px')};
      line-height: ${rem('35px')};
      font-weight: 400;
      text-transform: unset;
      color: #FFFFFF;
      margin-bottom: ${rem('40px')};
      text-shadow: 0px 0px 15px #00000029;

      ${({ theme }) => theme.tablet`
         ${({ theme }) => theme.ADAFont('17px')};
      `}
   `}

   // Hotel Landing for Ones with Benefits
   ${({section}) => (section == 'hotelLandingLoyalty') && css`
      ${({ theme }) => theme.ADAFont('24px')};
      line-height: ${rem('35px')};
      font-weight: 400;
      text-transform: unset;
      color: #FFFFFF;
      margin-bottom: ${rem('40px')};
      text-shadow: 0px 0px 15px #00000029;

      ${({ theme }) => theme.tablet`
         ${({ theme }) => theme.ADAFont('20px')};
         font-weight: 500;
      `}
   `}

   // Agent Enrollment Page
   ${({section}) => (section == 'emailPreferences') && css`
      ${({ theme }) => theme.ADAFont('18px')}
      text-align: left;
      margin-bottom: ${rem('27px')};
   `}

`;

const HomepageH5 = ({section, children}) => {
  return (
    <StyledHomepageH5  section={section} children={children} >
        {children}
    </StyledHomepageH5>
  )
}

HomepageH5.propTypes = {
    /**
    * Specify the content of your Text
    */
   children: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.array
    ]).isRequired,

   /**
   * Specify the section of your Text
   */
   section: PropTypes.string.isRequired
}

export default HomepageH5;


